<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	import Treeselect from '@riophae/vue-treeselect'
	import Profit from './Profit'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
			'treeselect': Treeselect,
			'profit': Profit,
		},
		data () {
			return {
				statuses: null,
				providers: null,
				categories: null,

				item: {
					attributes: [],
					extras: [],

					title: null,
					reference: null,
					short_title: null,
					description: null,
					short_description: null,
					keywords: null,
					url: null,

					purchase_base_price: null,
					purchase_discount: null,
					purchase_save: null,
					purchase_price: null,
					purchase_taxes: null,
					purchase_amount: null,
					purchase_total: null,

					base_price: null,
					discount: null,
					save: null,
					price: null,
					taxes: null,
					amount: null,
					total: null,

					profit_value: null,
					profit_percent: null,
					profit_val_measurement_unit: null,
					balance: null,

					total_measurement_unit: 1,

					stock: null,
					product_operation_id: 1,
					tax_id: null,
					measurement_unit_id: 1,
					provider_id: null,
					currency_id: null,

					plan_id: null,

					lang_id: 2,
					product_status_id: 1,

					media: {
						images: [],
						docs: [],
					},
				},

				tax: null,
				currency: null,
				
				totalPriceOutExtras: null,
			}
		},
		created() {
			this.init()
			this.currency = this.$platform.setting.currency
		},
		mounted() {
			this.$validator.extend('usedReference', {
				getMessage: field => 'Refencia no disponible.',
				validate: (value, [testProp]) => {
					if(value) {
						var data = {
							reference: value
						}

						return this.$http.post('admin/management/products/validation/reference', data)
						.then(response => {
							return {
								valid: response.body.valid
							}
						}).catch(function(response) {
							console.log(response)
						})
					} else {
						return false
					}
				}
			});

			[].slice.call(document.querySelectorAll('.sttabs')).forEach(function(el) {
				new CBPFWTabs(el);
			})
		},
		watch: {
			tax () {
				if(this.tax) {
					this.item.tax_id = this.tax.id
				} else {
					this.item.tax_id = null
				}
			},
			currency () {
				if(this.currency) {
					this.item.currency_id = this.currency.id
				}
			},
			//-- PURCHASE
				'item.purchase_base_price' () {
					this.item.purchase_base_price = this.$options.filters.checkDecimals(this.item.purchase_base_price)
					this.calculatePurchaseSave()
					this.calculatePurchasePrice()
					this.calculatePurchaseTaxes()
					this.calculatePurchaseAmount()
					this.calculatePurchaseTotal()
				},
				'item.purchase_price'() {
					this.$refs.profit.calculateProfit()
				},
			//-- PURCHASE

			//-- SALE
				'item.base_price' () {
					this.item.base_price = this.$options.filters.checkDecimals(this.item.base_price)
					this.calculateSave()
					this.calculatePrice()
					this.calculateTaxes()
					this.calculateAmount()
					this.calculateTotal()
				},
				'item.price'() {
					this.$refs.profit.calculateProfit()
				}
			//-- SALE
		},
		methods: {
			init() {
				this.getStatuses()
				this.getCategories()
				this.getProviders()
			},
			getStatuses: function() {
				this.$http.get('admin/management/products/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			getCategories: function() {
				this.$http.get('admin/management/products/categories')
					.then(response => {
						this.categories = response.body
					})
			},
			getProviders: function() {
				this.$http.get('admin/management/providers')
					.then(response => {
						this.providers = response.body
					})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
				})
			},
			//--
			store () {
				var loadingTop = Ladda.create(this.$refs.btnStoreTop)
				var loadingBottom = Ladda.create(this.$refs.btnStoreBottom)
				loadingTop.start()
				loadingBottom.start()
				this.$http.post('admin/management/products', this.item)
				.then(response => {
					var product = response.body.data
					loadingTop.stop()
					loadingBottom.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + "/admin/management/products/" + product.id + '/edit')
				}).catch(function(response) {
					console.log(response)
					loadingTop.stop()
					loadingBottom.stop()
					if(response.status == 409) {
						swal(response.statusText, response.body[0], "warning")
					}
				})
			},
			//-- SALES
				calculateDiscount() {
					if(this.item.base_price) {
						var base_price = parseFloat(this.item.base_price)
					} else {
						var base_price = 0
					}

					if(this.item.save) {
						var save = parseFloat(this.item.save)
					} else {
						var save = 0
					}

					if(save > base_price) {
						this.item.save = -Math.abs(save)
					}

					var discount = save * 100 / base_price

					this.item.discount = parseFloat(discount).toFixed(2)
				},
				calculateSave() {
					if(this.item.base_price) {
						var base_price = parseFloat(this.item.base_price)
					} else {
						var base_price = 0
					}

					if(this.item.discount) {
						var discount = parseFloat(this.item.discount)
					} else {
						var discount = 0
					}

					if(this.item.discount > 100) {
						var total = -Math.abs(base_price * discount / 100)
					} else {
						var total = base_price * discount / 100
					}

					this.item.save = parseFloat(total).toFixed(2)
				},
				calculatePrice() {
					if(this.item.base_price) {
						var base_price = parseFloat(this.item.base_price)
					} else {
						var base_price = 0
					}

					if(this.item.save) {
						var save = parseFloat(this.item.save)
					} else {
						var save = 0
					}

					var price = base_price - Math.abs(save)

					this.item.price = parseFloat(price).toFixed(2)
				},
				calculateTaxes() {
					if(this.tax) {
						if(this.item.price) {
							var price = parseFloat(this.item.price)
						} else {
							var price = 0
						}
						var taxes = price * this.tax.value / 100
						this.item.taxes = parseFloat(taxes).toFixed(2)
					} else {
						this.item.taxes = 0
					}
				},
				calculateAmount() {
					if(this.item.price) {
						var price = parseFloat(this.item.price)
					} else {
						var price = 0
					}

					if(this.item.taxes) {
						var taxes = parseFloat(this.item.taxes)
					} else {
						var taxes = 0
					}

					var amount = price + taxes

					this.item.amount = parseFloat(amount).toFixed(2)
				},
				calculateTotal() {
					if(this.item.amount) {
						var amount = parseFloat(this.item.amount)
					} else {
						var amount = 0
					}

					if(this.item.total_measurement_unit) {
						var total_measurement_unit = parseFloat(this.item.total_measurement_unit)
					} else {
						var total_measurement_unit = 0
					}

					var total = total_measurement_unit * amount

					var extras = this.item.extras
					if(extras.length) {
						extras.forEach(function(extra) {
							var value = Number(extra.sale_value)
							total = total + value
						})
					}
					
					this.item.total = parseFloat(total).toFixed(2)
					this.calculateTotalPriceOutExtras()
				},
				//-- EVENTS
					discountChange() {
						this.item.discount = this.$options.filters.checkDecimals(this.item.discount)
						this.calculateSave()
						this.calculatePrice()
						this.calculateTaxes()
						this.calculateAmount()
						this.calculateTotal()
					},
					saveChange() {
						this.item.save = this.$options.filters.checkDecimals(this.item.save)
						this.calculateDiscount()
						this.calculatePrice()
						this.calculateTaxes()
						this.calculateAmount()
						this.calculateTotal()
					},
			//-- SALES

			//-- PURCHASE
				calculatePurchaseDiscount() {
					if(this.item.purchase_base_price) {
						var purchase_base_price = parseFloat(this.item.purchase_base_price)
					} else {
						var purchase_base_price = 0
					}

					if(this.item.purchase_save) {
						var purchase_save = parseFloat(this.item.purchase_save)
					} else {
						var purchase_save = 0
					}

					if(purchase_save > purchase_base_price) {
						this.item.purchase_save = -Math.abs(purchase_save)
					}

					var purchase_discount = purchase_save * 100 / purchase_base_price

					this.item.purchase_discount = parseFloat(purchase_discount).toFixed(2)
				},
				calculatePurchaseSave() {
					if(this.item.purchase_base_price) {
						var purchase_base_price = parseFloat(this.item.purchase_base_price)
					} else {
						var purchase_base_price = 0
					}

					if(this.item.purchase_discount) {
						var purchase_discount = parseFloat(this.item.purchase_discount)
					} else {
						var purchase_discount = 0
					}

					if(this.item.purchase_discount > 100) {
						var total = -Math.abs(purchase_base_price * purchase_discount / 100)
					} else {
						var total = purchase_base_price * purchase_discount / 100
					}
					this.item.purchase_save = parseFloat(total).toFixed(2)
				},
				calculatePurchasePrice() {
					if(this.item.purchase_base_price) {
						var purchase_base_price = parseFloat(this.item.purchase_base_price)
					} else {
						var purchase_base_price = 0
					}

					if(this.item.purchase_save) {
						var purchase_save = Math.abs(parseFloat(this.item.purchase_save))
					} else {
						var purchase_save = 0
					}

					var purchase_price = purchase_base_price - purchase_save
					this.item.purchase_price = parseFloat(purchase_price).toFixed(2)
				},
				calculatePurchaseTaxes() {
					if(this.tax) {
						if(this.item.purchase_price) {
							var purchase_price = parseFloat(this.item.purchase_price)
						} else {
							var purchase_price = 0
						}
						var taxes = purchase_price * this.tax.value / 100
						this.item.purchase_taxes = parseFloat(taxes).toFixed(2)
					} else {
						this.item.purchase_taxes = 0
					}
				},
				calculatePurchaseAmount() {
					if(this.item.purchase_price) {
						var purchase_price = parseFloat(this.item.purchase_price)
					} else {
						var purchase_price = 0
					}

					if(this.item.purchase_taxes) {
						var purchase_taxes = parseFloat(this.item.purchase_taxes)
					} else {
						var purchase_taxes = 0
					}

					var purchase_amount = purchase_price + purchase_taxes

					this.item.purchase_amount = parseFloat(purchase_amount).toFixed(2)
				},
				calculatePurchaseTotal() {
					if(this.item.purchase_amount) {
						var purchase_amount = parseFloat(this.item.purchase_amount)
					} else {
						var purchase_amount = 0
					}

					if(this.item.total_measurement_unit) {
						var total_measurement_unit = parseFloat(this.item.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}
					
					var purchase_total = purchase_amount * total_measurement_unit

					var extras = this.item.extras
					if(extras.length) {
						extras.forEach(function(extra) {
							var value = Number(extra.purchase_value)
							purchase_total = purchase_total + value
						})
					}

					this.item.purchase_total = parseFloat(purchase_total).toFixed(2)
				},
				//--EVENTS
					purchaseDiscountChange() {
						this.item.purchase_discount = this.$options.filters.checkDecimals(this.item.purchase_discount)
						this.calculatePurchaseSave()
						this.calculatePurchasePrice()
						this.calculatePurchaseTaxes()
						this.calculatePurchaseAmount()
						this.calculatePurchaseTotal()
					},
					purchaseSaveChange() {
						this.item.purchase_save = this.$options.filters.checkDecimals(this.item.purchase_save)
						this.calculatePurchaseDiscount()
						this.calculatePurchasePrice()
						this.calculatePurchaseTaxes()
						this.calculatePurchaseAmount()
						this.calculatePurchaseTotal()
					},
			//-- PURCHASE

			calculateTotalPriceOutExtras() {
				if(this.item.total) {
					var total = parseFloat(this.item.total)
				} else {
					var total = 0
				}

				var extras = this.item.extras
				if(extras.length) {
					extras.forEach(function(extra) {
						var value = Number(extra.value)
						total = total - value
					})
				}

				var total_price_out_extras = total
				this.totalPriceOutExtras = parseFloat(total_price_out_extras).toFixed(2)
			},
			normalizerTreeselectCategory(node) {
				return {
					id: node.id,
					label: node.title,
					children: node.children,
				}
			}
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/management/products/views/Create.vue